import {
  IonContent,
  IonPage,
  useIonRouter,
} from "@ionic/react";
import React, { useEffect } from "react";

type Props = {};

export function LandingScreen({}: Props) {
  const router = useIonRouter();

  useEffect(() => {
    router.push("/nearby", "forward", "replace");
  }, [router]);

  return (
    <IonPage>
      <IonContent className="ion-padding">
        {/* This screen redirects immediately to /nearby */}
      </IonContent>
    </IonPage>
  );
}
